import mixpanel from 'mixpanel-browser';

const ENABLED = import.meta.env.VITE_MIXPANEL_ENABLED === 'true';
const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string;

export function initMixpanel() {
  if (!ENABLED || !TOKEN) return;

  mixpanel.init(TOKEN, {
    debug: import.meta.env.VITE_ENV === 'development',
    track_pageview: false, // we handle page views manually
    persistence: 'localStorage',
  });
}

export const analytics = {
  identify(userId: string, traits?: Record<string, unknown>) {
    if (!ENABLED) return;
    mixpanel.identify(userId);
    if (traits) mixpanel.people.set(traits);
  },

  track(event: string, properties?: Record<string, unknown>) {
    if (!ENABLED) return;
    mixpanel.track(event, properties);
  },

  page(name: string, properties?: Record<string, unknown>) {
    if (!ENABLED) return;
    mixpanel.track('Page View', { page: name, ...properties });
  },

  reset() {
    if (!ENABLED) return;
    mixpanel.reset();
  },
};
